// Inside the NotFound component
import  { useEffect } from 'react';

function NotFound() {
  useEffect(() => {
    // Redirect to 404.html if desired (or fallback)
    window.location.replace("/404.html");
  }, []);

  return null; // This component doesn't render anything as it's redirecting
}

export default NotFound;
